import React from 'react';

import Money from 'components/Money';
import Loader from 'components/Loader';

import './styles.css';

const PaymentSummaryBox = ({rentAndOneOff, deposit, label, extraClassName}) => (
  <div className="PaymentSummary__box">
    <div className="PaymentSummary__box__label">{label}</div>
    <div className="colab-centered-v">
      <div className="PaymentSummary__box__content">
        <div className={`PaymentSummary__box__balance__${extraClassName}`}>
          <Money amount={rentAndOneOff} balance />
        </div>
        <div className="PaymentSummary__box__label">Charges and payments</div>
      </div>
      <div>
        <div className={`PaymentSummary__box__balance__${extraClassName}`}>
          <Money amount={deposit} balance />
        </div>
        <div className="PaymentSummary__box__label">Deposit</div>
      </div>
    </div>
  </div>
);

const PaymentSummary = ({paymentSummary}) => {
  return (
    <div className="PaymentSummary">
      {paymentSummary && (
        <React.Fragment>
          <PaymentSummaryBox
            extraClassName="current"
            label="Current Balance"
            rentAndOneOff={paymentSummary.currentBalance.rentAndOneOff}
            deposit={paymentSummary.currentBalance.deposit}
          />
          <PaymentSummaryBox
            extraClassName="total"
            label="Total Balance"
            rentAndOneOff={paymentSummary.totalBalance.rentAndOneOff}
            deposit={paymentSummary.totalBalance.deposit}
          />
        </React.Fragment>
      )}
      {!paymentSummary && <Loader />}
    </div>
  );
};

export default PaymentSummary;
